import { AGENT } from 'conversations-message-history/constants/messageUses';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessageFooter from '../primary-message/components/PrimaryMessageFooter';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../p... Remove this comment to see the full error message
import ContentText from '../primary-message/ContentText';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import AutomatedMessageHeader from '../shared/components/AutomatedMessageHeader';
import AutomatedMessageContent from '../shared/components/AutomatedMessageContent';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getHistoryFormattedTimestamp } from 'conversations-message-history/util/getHistoryFormattedTimestamp';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getOfficeHoursStartTime } from 'conversations-message-history/office-hours-message/operators/officeHoursMessageGetters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getPlainText } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PureComponent } from 'react';
import Small from 'UIComponents/elements/Small';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import styled from 'styled-components';
import AutomatedMessageAvatar from '../avatar/AutomatedMessageAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "OfficeHoursMessage__StyledDiv",
  componentId: "sc-16ihk7q-0"
})(["display:flex;align-items:center;flex-direction:column;width:100%;"]);
const StyledContentColumn = styled.div.withConfig({
  displayName: "OfficeHoursMessage__StyledContentColumn",
  componentId: "sc-16ihk7q-1"
})(["display:flex;flex-direction:row;"]);
class OfficeHoursMessage extends PureComponent {
  render() {
    const {
      message,
      positionDescriptors
    } = this.props;
    const startTime = getOfficeHoursStartTime(message);
    const plainText = getPlainText(message);
    const sameTime = plainText && plainText.includes(getHistoryFormattedTimestamp(startTime));
    return /*#__PURE__*/_jsxs(PrimaryMessage, {
      positionDescriptors: positionDescriptors,
      use: AGENT,
      children: [/*#__PURE__*/_jsx(PrimaryMessageContent, {
        children: /*#__PURE__*/_jsxs(StyledContentColumn, {
          children: [/*#__PURE__*/_jsx(AutomatedMessageAvatar, {}), /*#__PURE__*/_jsxs(StyledDiv, {
            children: [/*#__PURE__*/_jsx(AutomatedMessageHeader, {
              message: message
            }), /*#__PURE__*/_jsx(AutomatedMessageContent, {
              children: /*#__PURE__*/_jsx(ContentText, {
                contentText: getPlainText(message)
              })
            })]
          })]
        })
      }), !sameTime && /*#__PURE__*/_jsx(PrimaryMessageFooter, {
        children: /*#__PURE__*/_jsxs(Small, {
          use: "help",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.availability.small"
          }), /*#__PURE__*/_jsx(UIHelpIcon, {
            className: "m-x-1",
            tooltipPlacement: "bottom",
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-message-history.availability.tooltip"
            })
          })]
        })
      })]
    });
  }
}
OfficeHoursMessage.displayName = 'OfficeHoursMessage';
OfficeHoursMessage.propTypes = {
  message: RecordPropType('OfficeHoursMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default OfficeHoursMessage;